module.exports = __webpack_public_path__ + "img/Share of Voice.66df0620.svg";